class SizePopupOpener extends HTMLElement {
  constructor() {
    super()

    this.sizesModal = document.querySelector('modal-dialog:has(.sizes__container)')
    this.sizesTranslations = ['size','sizes','rozmiar','rozmiary']

    subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
      const cart = JSON.parse(localStorage.getItem('cart'))
      const productId = e?.data?.html?.querySelector("input[name='product-id']")?.value

      if (!window.sessionStorage.getItem("sizePopupSeen") && cart?.items?.find(item => item.product_id == productId) && this.sizesModal) {
        cart?.items?.filter((item) => item.product_id == productId)?.forEach((item) => {
          item?.options_with_values?.forEach((option, idx) => {
            if (this.sizesTranslations.includes(option?.name.toLowerCase())) {
              if (e?.data?.variant?.options[idx] != option.value) {
                return this.enableOpener()
              } else {
                this.disableOpener()
              }
            }
          })
        })
      } else {
        this.disableOpener()
      }
    })

    this.parentElement.addEventListener("click", () => {
      if (this.hasAttribute('active')) {
        const modal = document.querySelector(this.getAttribute("data-modal"))
        if (modal) {
          modal.show()
          window.sessionStorage.setItem("sizePopupSeen", true)

          const addToCartButton = modal.querySelector('#add-to-cart')
          const openSizeModalButton = modal.querySelector('#open-size-modal')

          addToCartButton.addEventListener('click', () => { 
            modal.hide()
            this.submitProductForm()
          }, {once: true})

          openSizeModalButton.addEventListener('click', () => { 
            modal.hide()
            this.sizesModal.show()
          }, {once: true})
        } 
      }
    })
  }

  enableOpener() {
    this.setAttribute('active', '')
  }

  disableOpener() {
    this.removeAttribute('active')
  }

  submitProductForm() {
    const productForm = document.querySelector("product-form")
    const form = productForm?.querySelector('form')
    
    if (form) {
      form.requestSubmit()
    }
  }
}

customElements.define("size-popup-opener", SizePopupOpener)